<template>
  <div class="ota-small-light">
    <template v-if="countryCode === CountryCodes.spain">
      <span v-if="address.streetType" class="mb-1 mr-1 inline-block" v-text="address.streetType" />
      <span class="mb-1 mr-1 inline-block" v-text="address.street" />
      <template v-if="address.building || address.floor">
        <span v-if="address.building" class="mr-1 mb-1 inline-block" v-text="address.building" />
        <span v-if="address.floor" v-text="address.floor" />
      </template>
      <span v-if="address.houseNumber" class="mb-1 inline-block" v-text="address.houseNumber" />
      <br>
      <span class="mb-1 inline-block" v-text="address.postalCode" />
      <span class="ml-1" v-text="address.city" />
      <template v-if="address.region">
        <br>
        <span class="mb-1 inline-block" v-text="address.region" />
      </template>
      <br>
      <span v-text="address.country" />
    </template>
    <template v-else-if="countryCode === CountryCodes.france">
      <span v-if="address.houseNumber" class="mr-1 mb-1 inline-block" v-text="address.houseNumber" />
      <span v-text="address.street" />
      <br>
      <span class="mb-1 inline-block" v-text="address.postalCode" />
      <span class="ml-1" v-text="address.city" />
      <br>
      <span v-text="address.country" />
    </template>
    <template v-else-if="countryCode === CountryCodes.unitedKingdom">
      <span v-if="!/^\d+$/.test(address.houseNumber)" v-text="address.street.replace(address.houseNumber.trim(), '')" />
      <span v-else v-text="address.street" />
      <span v-if="address.houseNumber" class="mb-1 inline-block" v-text="address.houseNumber" />
      <br>
      <span v-if="address.building" class="mb-1 inline-block" v-text="address.building" />
      <br v-if="address.building">
      <span v-text="address.city" />
      <span class="mb-1 inline-block" v-text="address.postalCode" />
      <br>
      <span v-text="address.country" />
    </template>
    <template v-else-if="countryCode === CountryCodes.belgium">
      <span v-if="address.building" v-text="address.building" />
      <span v-if="address.floor" v-text="address.floor" />
      <br v-if="address.building || address.floor">
      <span class="mr-1 mb-1 inline-block" v-text="address.street" />
      <span v-text="address.houseNumber" />
      <br>
      <span class="mb-1 inline-block" v-text="address.postalCode" />
      <span class="ml-1" v-text="address.city" />
      <br>
      <span v-text="address.country" />
    </template>
    <template v-else-if="countryCode === CountryCodes.italy">
      <span class="mr-1 mb-1 inline-block" v-text="`${address.street},`" />
      <span v-if="address.houseNumber" v-text="address.houseNumber.trim()" />
      <br>
      <span class="mb-1 inline-block" v-text="address.postalCode" />
      <span class="ml-1" v-text="address.city" />
      <span v-if="address.region" class="ml-1" v-text="address.region" />
      <br>
      <span v-text="address.country" />
    </template>
    <template v-else-if="countryCode === CountryCodes.luxembourg">
      <span class="mr-1 mb-1 inline-block" v-text="address.houseNumber" />
      <span v-if="address.street" v-text="address.street" />
      <br>
      <span class="mb-1 inline-block" v-text="address.postalCode" />
      <span class="ml-1" v-text="address.city" />
      <br>
      <span v-text="address.country" />
    </template>
    <template v-else-if="countryCode === CountryCodes.ireland">
      <span v-if="address.houseNumber" class="mr-1 inline-block" v-text="address.houseNumber" />
      <span v-if="address.building" v-text="address.building" />
      <span v-if="address.street" v-text="address.street" />
      <template v-if="address.region">
        <br>
        <span v-if="address.region" v-text="address.region" />
      </template>
      <br>
      <span v-text="address.city" />
      <template v-if="address.postalCode">
        <br>
        <span v-text="address.postalCode" />
      </template>
      <br>
      <span v-text="address.country" />
    </template>
    <template v-else-if="countryCode === CountryCodes.portugal">
      <span class="mr-1 mb-1 inline-block" v-text="address.street" />
      <span v-if="address.houseNumber" v-text="address.houseNumber.trim()" />
      <br>
      <span class="mb-1 inline-block" v-text="address.city" />
      <span class="ml-1" v-text="address.postalCode" />
      <br>
      <span v-text="address.region" />
      <br>
      <span v-text="address.country" />
    </template>
    <template v-else>
      <span class="mr-1 mb-1 inline-block" v-text="address.street" />
      <span v-if="address.houseNumber" v-text="address.houseNumber.trim()" />
      <span v-if="address.annex" v-text="address.annex" />
      <br>
      <span class="mb-1 inline-block" v-text="address.postalCode" />
      <span class="ml-1" v-text="address.city" />
      <br>
      <span v-text="address.country" />
    </template>
  </div>
</template>

<script>
import { CountryCodes } from '@/enums/general'

export default {
  name: 'AddressFormat',
  props: {
    address: {
      type: Object,
      required: true
    },
    countryCode: {
      type: String,
      default: CountryCodes.netherlands
    }
  },
  data () {
    return {
      CountryCodes
    }
  }
}
</script>
